import React from 'react';
import { Formik, Form, Field } from 'formik';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as dataSeed from '../shared/DataSeed';
import {
    Button, Label, FormGroup, Row, Col, Input, Alert, Modal, ModalBody, ModalFooter, Spinner, UncontrolledAlert,
    Fade, ModalHeader
} from 'reactstrap';
import { bankValidationActions } from '../store/BcaValidation.Reducer';
import 'react-html5-camera-photo/build/css/index.css';

class ChooseBank extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            load: false,
            error: false,
            success: -1,
            message: 'Gagal Validasi',
            norek: localStorage.getItem('norek') || '',
            nama: localStorage.getItem('nama') || '',
            pilihBank: localStorage.getItem('pilihBank') ||'',
            kepemilikanAsset: localStorage.getItem('kepemilikanAsset') || '1',
            agreementCheck: false,
            agreementBO: false,
            validationCode: '',
            isLoading: false,
            openModal: false,
            fotoSpecimen: '',
            imageHash: '', //Date.now(),
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleValidateClick = this.handleValidateClick.bind(this);
        this.toggle = this.toggle.bind(this);
        this.validateNumber = this.validateNumber.bind(this);
    }

    validateNumber(evt) {
        var theEvent = evt || window.event;

        // Handle paste
        if (theEvent.type === 'paste') {
            key = evt.clipboardData.getData('text/plain');
        } else {
            // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]/;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }
    }

    handleChange(event) {
        const name = event.target.name;
        const value = event.target.value;
        this.setState({ [name]: value });
        if (name === 'norek') {
            this.props.setNorek(event.target.value);
        }
        if (name === 'nama') {
            this.props.setNamaPemegangRekening(event.target.value.toUpperCase());
            this.setState({ nama: event.target.value.toUpperCase() });
        }
        if (name === 'agreement') {
            this.setState({ agreementCheck: event.target.checked });
        }

        if (name === 'agreementBO') {
            this.setState({ agreementBO: true })
        }

        localStorage.setItem('pilihBank', value);
    }

    async handleValidateClick() {
        if (this.state.pilihBank.length > 0) {
            localStorage.setItem('pilihBank', this.state.pilihBank);
            localStorage.setItem('page',-2);
            this.setState({page: -2});
        } else {
            alert('Mohon isi data dengan lengkap');
        }
    }

    toggle() {
        this.setState(({ openModal }) => ({ openModal: !openModal }));
    }

  
    onChangeSelection(e, setFieldValue) {
        this.setState({ pilihBank: e.target.value });
        setFieldValue(e.target.name, e.target.value);
        localStorage.setItem('pilihBank', e.target.value);
    };
    

    render() {
      
        const { bcaValidation, values, setFieldValue } = this.props;

        let msgAlert, verifikasiButton;

        verifikasiButton = <Button type="button" color="primary" onClick={() => this.props.nowPilihBank(values)} className="btn-block" >Pilih</Button>;

        return (
            <React.Fragment>
                <Modal isOpen={bcaValidation.isLoading}>
                    <ModalBody className="text-center">
                        <Spinner color="success" /><br />Loading..
                    </ModalBody>
                </Modal>

                {this.state.error ?
                    <Modal isOpen={bcaValidation.error}>
                        <ModalHeader size={"sm"}>{bcaValidation.entity.title}</ModalHeader>
                        <ModalBody className="text-center">
                            <ul>
                                {Object.keys(bcaValidation.entity.errors).map(function (key) {
                                    return <li className={"text-danger"}>{bcaValidation.entity.errors[key][0]}</li>
                                }, this)
                                }
                            </ul>
                        </ModalBody>
                        <ModalFooter>
                            <Button size={"sm"} color="primary" onClick={() => this.setState({ error: false })}>Close</Button>
                        </ModalFooter>
                    </Modal>
                    : null}

                <Fade in={true}>
                    {/*<Formik >*/}

                      {/*  <Form autoComplete="off">*/}
                    <UncontrolledAlert color="warning">Sebelum melanjutkan mohon mempersiapkan dokumen pendukung KTP.</UncontrolledAlert>
                            <p className="text-danger"><b>Sebaiknya menggunakan browser Chrome / Firefox / Safari</b></p>
                    <p>Panduan Pembukaan Rekening online <a href="https://yb.co.id/howtoregist" target="__blank">Klik disini</a></p>
                            {msgAlert}

                            <FormGroup tag="fieldset">
                                <legend>Pilih Bank Rekening yang Anda Miliki</legend>
                                <Row>
                                    <Col md="6">
                                        <FormGroup>
                                            <Label>Bank<span className="text-danger">*</span></Label>

                                            {bcaValidation.entity.ResponseCode === "00" ?
                                                <Input type="text" disabled value="Diri Sendiri" bsSize="sm"/>
                                        : <Input type={"select"}
                                                name="BankCode2"
                                                    className="form-control-sm"
                                                    onChange={(e) => this.onChangeSelection(e, setFieldValue)}                                                >
                                            <option value="" >-- Pilih --</option>
                                            <option selected={values.BankCode2 === "BCA"} value={"BCA"}>BCA (Bank Central Asia)</option>
                                            <option selected={values.BankCode2 === "BRI"} value={"BRI"}>BRI (Bank Rakyat Indonesia)</option> 
                                        </Input>           
                                    }
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="3" xs="12" sm="12">
                                        {verifikasiButton}
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md="12">
                                        Estimasi pembuatan akun 2 x 24 Jam Kerja*<br />
                                        Syarat dan Ketentuan Berlaku*
                                    </Col>
                                </Row>
                            </FormGroup>
                    {/*    </Form>*/}
                    {/*</Formik>*/}
                </Fade>
            </React.Fragment>
        )
    }
}
const mapStateToProps = (state) => ({
    bcaValidation: state.bcaValidation
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        requestBankValidation: bankValidationActions.requestBankValidation
    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ChooseBank);



// WEBPACK FOOTER //
// ./src/components/ChooseBank.js